import { translate } from '@washed/i18n';
import { Reveal } from '../motion/Reveal.js';
import { MaskedReveal } from '../motion/MaskedReveal.js';
import { brandify } from '../components/Brand.js';
import { MascotMotion } from '../components/MascotMotion.js';
import styles from './Service.module.css';

export interface ServiceProps {
  locale: 'fr' | 'en';
}

const STEPS = [
  { number: 1, mascot: 'thread' },
  { number: 2, mascot: 'basket' },
  { number: 3, mascot: 'guardian' },
] as const;

export function Service({ locale }: ServiceProps) {
  const t = (k: Parameters<typeof translate>[0]) => translate(k, locale);

  return (
    <section id="service" className={styles.service}>
      <header className={styles.head}>
        <Reveal as="h2" variant="mask" className={styles.h2}>
          <MaskedReveal>{t('marketing.service.head')}</MaskedReveal>
        </Reveal>
        <Reveal as="p" className={styles.lede} i={1}>
          {t('marketing.service.subhead')}
        </Reveal>
      </header>

      <div className={styles.acts}>
        {STEPS.map(({ number, mascot }) => (
          <Reveal as="article" key={number} className={styles.act} i={number - 1}>
            <div className={styles.illustration}>
              <MascotMotion
                kind={mascot}
                width={520}
                height={620}
                className={styles.mascotMotion}
              />
            </div>
            <div className={styles.actHead}>
              <p className={`${styles.day} smallcaps`}>{t(`marketing.service.act${number}.day`)}</p>
              <h3 className={styles.title}>{t(`marketing.service.act${number}.title`)}</h3>
            </div>
            <p className={styles.bodyText}>{brandify(t(`marketing.service.act${number}.body`))}</p>
            <footer className={styles.meta}>
              <span>{t(`marketing.service.act${number}.meta_label`)}</span>
              <span>{t(`marketing.service.act${number}.meta_value`)}</span>
            </footer>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
